import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import Loader from "../../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import {
  getActivosFijosById,
  getActivosFijosSimples,
  getHistoricos,
  GuardarHistorico,
} from "../../../../../API/Global/ActivosFijos/ActivosFijosRequest";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { getAreasAct } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getPersonall } from "../../../../../API/RRHH/Personal/PersonalRequest";

const HistoricoTransferenciaScreen = ({
  selectedActivo,
  setShowVisible,
  getInfoGeneral,
  IdActivo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [editar, setEditar] = useState(false);
  const [data, setData] = useState([]);
  const [areas, setAreas] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [selectedDetalles, setSelectedDetalles] = useState([]);

  const getInfo = async () => {
    setLoading(true);

    const dataTempo = await getHistoricos();

    const areas = await getAreasAct();
    setAreas(areas);

    const personalTempo = await getPersonall();
    setPersonal(personalTempo);
    if (selectedActivo?.IdActivo > 0) {
      setEditar(true);
      let datosFiltrados = dataTempo.filter(
        (i) => i?.IdActivo === selectedActivo?.IdActivo
      );
      setData(datosFiltrados);
    } else {
      setEditar(false);
      let datosFiltrados = dataTempo.filter((i) => i?.IdActivo === IdActivo);
      setData(datosFiltrados);
    }

    setLoading(false);
  };

  const agregarDet = () => {
    let newRowData = [...data];

    let index = -(data?.length + 1);

    const newData = {
      IdHistorico: index,
      IdUserCreated: userAuth?.IdUser,
      UserName: userAuth?.UserName,
      IdActivo: selectedActivo?.IdActivo,
      CodigoActivo: selectedActivo?.CodigoActivo,
      NombreActivo: selectedActivo?.NombreActivo,
      DateCreateST: new Date(),
    };

    newRowData.push(newData);
    setData(newRowData);
  };

  const eliminarDatos = () => {
    let IdPositivos = selectedDetalles.filter((e) => e.IdHistorico > 0);
    if (IdPositivos.length > 0) {
      toastShow(
        toast,
        "warn",
        "Datos",
        "No se pueden eliminar datos almacenados anteriormente."
      );
    }
    setData((prev) => prev.filter((e) => e.IdHistorico > 0));
    setSelectedDetalles([]);
  };

  const guardarDatos = async () => {
    const areaInvalida = data.some(
      (detalle) => !detalle.IdArea || detalle.IdArea <= 0
    );
    const personalInvalido = data.some(
      (detalle) => !detalle.IdPersonal || detalle.IdPersonal <= 0
    );

    if (areaInvalida) {
      toastShow(toast, "warn", "Advertencia", "Es requerido el Área.");
      return;
    }

    if (personalInvalido) {
      toastShow(toast, "warn", "Advertencia", "Es requerido el Personal.");
      return;
    }

    setLoading(true);

    const Datos = data
      .filter((detalle) => detalle.IdHistorico < 0)
      .map((detalle) => ({
        Comentario: detalle.Comentario ?? "",
        IdArea: detalle.IdArea,
        IdPersonal: detalle.IdPersonal,
        IdActivo: detalle.IdActivo,
        IdUserCreated: detalle.IdUserCreated,
      }));

    const resultado = await GuardarHistorico(Datos);
    if (resultado[0]?.ESTADO === 1) {
      toastShow(toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
      const infoNueva = await getActivosFijosById(selectedActivo?.IdActivo);
      getInfoGeneral(infoNueva[0]);
      setShowVisible(false);
      setLoading(false);
    } else {
      toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
    }
    setLoading(false);
  };

  //Tabla
  const columns = [
    {
      field: "IdHistorico",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdHistorico,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      editable: (params) => params.data?.IdHistorico < 0,
      className: "XXXlarge",
    },
    {
      header: "Area",
      headerEn: "Area",
      field: "Area",
      editable: (params) => params.data?.IdHistorico < 0,
      Format: "AutoComplete",
      value: "IdArea",
      label: "Area",
      items: areas,
    },
    {
      field: "NombreConcatenado",
      header: "Personal",
      headerEn: "Personal",
      filter: true,
      editable: (params) => params.data?.IdHistorico < 0,
      Format: "AutoComplete",
      value: "IdPersonal",
      label: "NombreConcatenado",
      items: personal,
    },

    {
      field: "CodigoActivo",
      header: "Código Activo",
      headerEn: "Asset Code",
      Sumary: "count",
      className: "Xsmall",
    },
    {
      header: "Activo",
      headerEn: "Asset",
      field: "NombreActivo",
      className: "Xlarge",
    },
    {
      header: "Usuario Creo",
      headerEn: "Created User",
      field: "UserName",
      className: "large",
    },
    {
      header: "Fecha",
      headerEn: "Date",
      field: "DateCreateST",
      className: "large",
      Format: "Date",
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    key: "IdHistorico",
    selected: selectedDetalles,
    setSelected: setSelectedDetalles,
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div style={{ height: "50vh" }}>
      <Toast ref={toast} />
      <Loader loading={loading} />
      {editar && (
        <div className="d-flex gap-2 my-2">
          <Button icon="pi pi-refresh" onClick={getInfo} />
          <Button
            icon="pi pi-plus"
            onClick={agregarDet}
            disabled={data?.some((item) => item.IdHistorico < 0)}
          />
          <Button
            icon="pi pi-save"
            disabled={!data?.some((item) => item.IdHistorico < 0)}
            onClick={guardarDatos}
          />
          <Button
            icon="pi pi-times"
            className="p-button-danger"
            disabled={selectedDetalles.length <= 0}
            onClick={eliminarDatos}
          />
        </div>
      )}
      <div style={{ height: selectedActivo?.IdActivo ? "45vh" : "60vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default HistoricoTransferenciaScreen;
